module.exports = __webpack_public_path__ + "static/media/apple-store-btn.e17fd78d.png";